const values = {
  DOMAIN: "https://api.primaltcg.com/"
}
export default values;